module.exports = __webpack_public_path__ + "static/img/menu-about-contact.9788d406.png";